import { Layer } from 'react-map-gl';
import { defaultSymbolLayerLayoutProps } from '../../utils/layers';
import { chevronImageKey } from '../../utils/images';

type Props = {
  beforeId: string;
  chevronLayerId: string;
  hide?: boolean;
  opacity?: number;
  sourceId: string;
  symbolSpacing?: number;
};

const ChevronLayer = ({ beforeId, chevronLayerId, hide, opacity = 1, sourceId, symbolSpacing = 50 }: Props) => {
  return (
    <Layer
      beforeId={beforeId}
      id={chevronLayerId}
      source={sourceId}
      type="symbol"
      layout={{
        ...defaultSymbolLayerLayoutProps,
        'icon-image': ['image', chevronImageKey],
        'icon-rotate': 90,
        'symbol-placement': 'line',
        'symbol-spacing': symbolSpacing,
        'icon-allow-overlap': true,
        'icon-ignore-placement': true,
        visibility: hide ? 'none' : 'visible'
      }}
      paint={{ 'icon-opacity': opacity }}
    />
  );
};

export default ChevronLayer;
